import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';

import { ContextLocalStorageConsumer } from 'Components/LocalStorageProvider/LocalStorageContext';

const withLocalStorage = Component => {
    const ComponentWithLocalStorage = props => (
        <ContextLocalStorageConsumer>
            {
                localStorage => <Component { ...{ localStorage } } { ...props } />
            }
        </ContextLocalStorageConsumer>
    );

    ComponentWithLocalStorage.displayName = `withLocalStorage(${Component.displayName || Component.name})`;

    return hoistNonReactStatic(ComponentWithLocalStorage, Component);
};

export default withLocalStorage;
